var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgModule1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 653,
    viewBox: "0 0 708 653",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_309_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.208 539.325C198.909 577.572 203.81 610.12 184.51 650.613C168.887 683.395 147.786 697.525 111.238 703.861C111.238 703.861 96.874 709.165 76.9564 695.233C57.0387 681.302 50.9699 660.182 49.0808 629.391C47.1894 598.603 94.2125 503.03 94.2125 503.03C94.2125 503.03 74.0405 496.965 62.6192 501.596C48.9337 507.145 33.3418 530.415 33.3418 530.415L2.82778 525.308C2.82778 525.308 21.1055 427.69 30.3577 415.27C39.6099 402.849 44.3684 400.273 52.718 396.372C61.0676 392.47 131.26 387.841 202.6 414.714C273.94 441.587 284.825 452.845 341.248 457.67C367.212 459.892 407.937 456.789 407.937 456.789C407.937 456.789 334.415 392.766 288.804 350.142C236.056 300.85 204.747 273.933 196.309 275.411C187.871 276.889 182.652 300.101 182.652 300.101L148.281 289.049C148.281 289.049 165.038 182.988 167.108 173.219C169.179 163.449 183.468 148.386 200.065 145.497C214.217 143.034 235.603 155.299 235.603 155.299L422.731 330.168L457.758 292.677C457.758 292.677 369.511 168.077 363.144 159.786C356.776 151.494 348.603 160.242 348.603 160.242L337.192 180.009L314.586 158.884L339.762 84.098C339.762 84.098 323.248 91.5308 312.113 91.0313C299.189 90.452 281.334 78.6541 281.334 78.6541L314.417 -12.1501C314.417 -12.1501 333.828 -0.551387 347.62 0.151011C364.973 1.03516 389.544 -14.5088 389.544 -14.5088L364.28 57.8542L388.515 57.0933C388.515 57.0933 416.137 85.9676 432.736 105.44C460.584 138.111 499.015 193.124 499.015 193.124L463.596 286.428L532.306 207.849L554.293 212.011L555.757 318.713L434.33 448.682C434.33 448.682 491.241 422.237 519.72 395.053C551.567 364.652 581.796 300.913 581.796 300.913C581.796 300.913 639.762 194.106 640.693 119.533C640.975 96.7912 645.386 82.2806 636.149 61.449C625.271 36.9206 592.281 22.7957 585.914 14.5043C579.546 6.21292 580.448 -2.30672 586.109 -13.4019C591.771 -24.4971 637.002 -14.9997 659.697 8.54864C682.391 32.0971 684.973 83.0854 687.269 132.627C690.346 199.068 678.686 237.502 655.756 299.804C631.839 364.783 613.526 402.075 566.718 453.017C518.143 505.881 475.118 535.954 413.894 553.646C352.67 571.338 330.093 566.522 276.924 556.733C251.565 552.066 213.208 539.325 213.208 539.325ZM213.208 539.325L168.065 532.251L213.208 539.325ZM168.065 532.251C168.065 532.251 133.626 541.083 119.223 556.832C108.945 568.075 98.4718 586.597 101.072 591.367C103.672 596.138 126.949 593.536 140.926 586.477C158.911 577.394 171.283 553.985 172.186 545.465C173.088 536.945 168.065 532.251 168.065 532.251Z",
    fill: "#CF072C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_309_450",
    x: -17.1719,
    y: -34.0223,
    width: 724.927,
    height: 762.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_309_450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_309_450",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgModule1);
export default __webpack_public_path__ + "static/media/bg-module-1.e074012bb270fb56448bda7789e51c58.svg";
export { ForwardRef as ReactComponent };